import { render, staticRenderFns } from "./RollbackModal.vue?vue&type=template&id=4088b024"
import script from "./RollbackModal.vue?vue&type=script&lang=js"
export * from "./RollbackModal.vue?vue&type=script&lang=js"
import style0 from "./RollbackModal.vue?vue&type=style&index=0&id=4088b024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports